module.exports = __webpack_public_path__ + "img/roll.f48df06b.jpg";